<template>
    <div :id="'videoCallContainer-' + this.messageId" :key="'videoCallContainer-' + this.messageId + '-' + this.patientReady">
        <div :id="'videoCall-' + this.messageId">
        <template v-if="this.$root.video_enabled && !this.$root.video_ready">
            <p class='p-1' style='border: 1px solid'>
                {{ $t('translations.waiting_for_video_to_initialise')}}
            </p>
        </template>
        <template v-else-if="this.is_staff() && !this.patientReady">
            <p class='p-1' style='border: 1px solid'>
                {{ autobrand('translations.waiting_for_patient_to_init_video')}}
            </p>
        </template>
        
        </div>
        <button v-if='chromeless' id="call-btn" class="btn btn-success">{{ $t('translations.start_video_call')}}</button>
		<template v-if="$root.showBreakout()">
			<p class='pt-2 pb-2'>{{ autobrand("translations.video_breakout_link_pre")}} <a href="#" style="color: inherit; text-decoration: underline;" v-on:click='$root.breakout(); return false'>{{ autobrand("translations.breakout_link")}}</a></p>
		</template>
    </div>
</template>

<script>
export default {
    props: {
        videoRoom: null,
        messageId: null,
        patientReady: {
            default: 0
        }
    },
    data: function() {
        return {
            clientId: "f8akcmnjXhPL",
            chromeless: 0,
            started_at: null,
            ended_at: null,
            notification_sent: false,
        }
    },
    computed: {
        video_ready() {
            return this.$root.video_ready;
        }
    },
    watch: {
        patientReady: function(ready) {
            if(this.is_staff())
            {
                if(ready) {
                    Vue.nextTick(() => {
                        this.initEmbed();
                        
                    });
                }
                else {
                    this.$root.gruveo_embed = null;
                    //this.$forceUpdate();
                }
            }
        },
        video_ready: function(ready) {
            if(ready 
                && (
                    this.is_patient() 
                    || (this.is_staff() && this.patientReady)
                )) {
                this.initEmbed();
            }
        }
    },
    mounted() {
		this.$root.gruveo_embed = null;
        if(this.$root.video_enabled && this.$root.video_ready && this.videoRoom) {
            if(this.is_patient() || this.patientReady) {
                this.initEmbed();
            }
        }
    },
    methods: {
        initEmbed() {
            if(!this.$root.gruveo_embed) {
                this.$root.gruveo_embed = new Gruveo.Embed('videoCall-' + this.messageId, {
                    responsive: 1,
                    embedParams: {
                        clientid: this.clientId,
                        code: this.videoRoom,
                        chromeless: this.chromeless,
                        color: "ffffff",
                        branding: 0,
                        chat: 0,
                        enableedgesupport: 1,
                    }
                })
                .on("error", this.onEmbedError)
                .on("requestToSignApiAuthToken", this.onEmbedRequestToSignApiAuthToken)
                .on("ready", this.onEmbedReady)
                .on("stateChange", this.onEmbedStateChange);

                Vue.nextTick(() => {
                    document.getElementById('videoCallContainer-' + this.messageId).scrollIntoView(false);
                });
            }
        },
        onEmbedError(e) {
            console.error("Received error " + e.error + ".");
        },

        onEmbedRequestToSignApiAuthToken(e) {
            axios.post('/gruveo-signer.php',
                    e.token)
                .then((res) => {
						this.$root.gruveo_embed.authorize(res.data);
                    })
                .catch((error) => {

                });
        },

        onEmbedReady(e) {
            console.log("onEmbedReady");
            if(this.chromeless) {
                document.getElementById("call-btn").addEventListener("click", () => {
                    this.$root.gruveo_embed.call(this.videoRoom, true);
                });
            }
        },
        setStartVideo() {
            //this.started_at = this.moment().format('YYYY-MM-DD\THH:mm:ss');
            var data = {message_id: this.messageId, /*started_at: this.started_at*/};

            axios.put('/api/v1/videos/setStartVideo', data).then((res) => {
                this.started_at = res.data.video.started_at;
            })
            .catch((error) => {
            });
        },
        setEndVideo() {
            //this.ended_at =  this.moment().format('YYYY-MM-DD\THH:mm:ss');
            var data = {message_id: this.messageId, /*ended_at: this.ended_at*/};

            return axios.put('/api/v1/videos/setEndVideo', data).then((res) => {
                this.ended_at = res.data.video.ended_at;
            })
            .catch((error) => {
            });
        },
        videoCallReady() {
            //this.ended_at =  this.moment().format('YYYY-MM-DD\THH:mm:ss');
            var data = {message_id: this.messageId, /*ended_at: this.ended_at*/};

            return axios.put('/api/vp1/videos/videoCallReady', data).then((res) => {
            })
            .catch((error) => {
            });
        },
        videoCallResetReady() {
            var data = {message_id: this.messageId};

            return axios.put('/api/vp1/videos/videoCallResetReady', data).then((res) => {
            })
            .catch((error) => {
            });
        },
        onEmbedStateChange(e) {
            console.log("onEmbedStateChange: " + e.state);
            console.log("notification_sent: " + this.notification_sent);
            console.log("callDuration: " + e.callDuration);
            // no-webrtc
            if(this.is_staff()) {
                switch(e.state) {
                    case "call":
                        this.setStartVideo();
                        // setTimeout(() => {
                        //     alert("Ending");
                        //     this.$root.gruveo_embed.end();
                        // }, 20000);
                        break;
                    case "ready":
                        if(e.callDuration) {
                            console.log("onEmbedStateChange: callDuration: " + e.callDuration);
                            this.setEndVideo()
                            .then(() => {
                                this.$emit("end-call", {started_at: this.started_at, ended_at: this.ended_at});
                            });
                        }
                        break;
                }
            }
            if(this.is_patient()) {
                switch(e.state) {

                    case "call-setup":
                        // This fires 3 times per call, with no difference in the event to
                        // tell which is which, or why it fires that many times.
                        if(!this.notification_sent) {
                            this.notification_sent = true;
                            this.videoCallReady();
                        }


                        break;
                    case "ready":
                        this.notification_sent = false;
                        if(e.callDuration === 0) {
                            console.log("onEmbedStateChange: callDuration: " + e.callDuration);
                            this.videoCallResetReady();
                        }
                        break;
                }
            }
        }
    }

}
</script>
